
import { defineComponent, PropType } from "vue";

/**
 * Las formas las define el BACKEND
 * (`functions/src/System/Migration/cofounderRank.ts`) y viven en un `.ts`
 * aparte: `shims-vue.d.ts` declara `*.vue` con un solo export —el default—, así
 * que un `export interface` aquí dentro NO existiría para quien importe este
 * fichero. Ver la cabecera de `cofounderTypes.ts`.
 */
import type {
  CofounderReport,
  CofounderRow,
  CofounderWrite,
} from "./cofounderTypes";

export default defineComponent({
  name: "CofounderRanks",
  props: {
    report: { type: Object as PropType<CofounderReport>, required: true },
    /** Lo que escribió la ÚLTIMA ejecución. Vacío en una simple lectura. */
    writes: {
      type: Array as PropType<CofounderWrite[]>,
      default: () => [],
    },
    /**
     * LAS CUENTAS MARCADAS, y viven en el PADRE, no aquí.
     *
     * Es lo que viaja a la callable, así que su dueño tiene que ser quien la
     * llama. Guardarla dentro de este componente la dejaría fuera del alcance
     * del botón —que está arriba, al lado de «Refrescar»— y obligaría a
     * duplicarla; dos copias de una selección de dinero acaban discrepando.
     */
    selected: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  emits: ["toggle"],
  computed: {
    hora(): string {
      return new Date(this.report.generadoEn).toLocaleTimeString();
    },
  },
  methods: {
    estaMarcada(usernamePK: string): boolean {
      return this.selected.includes(usernamePK);
    },
    /**
     * Marcar/desmarcar UNA fila. No muta la prop: avisa al padre, que es el
     * dueño de la selección. Una fila bloqueada no llega aquí — su casilla está
     * deshabilitada — pero si llegara, el backend la refusaría igual.
     */
    alternar(usernamePK: string): void {
      this.$emit("toggle", usernamePK);
    },
    /**
     * Un valor crudo, tal cual vino. `null` se pinta como «(sin campo)» y no
     * como un guion mudo: el campo AUSENTE es un estado distinto de cualquier
     * número, y aquí es la diferencia entre un nodo recién creado y uno que
     * alguien puso a mano.
     */
    pinta(valor: unknown): string {
      if (valor === null || valor === undefined) return "(sin campo)";
      return typeof valor === "object" ? JSON.stringify(valor) : String(valor);
    },
    /**
     * QUÉ falta exactamente. «Incompleta» a secas obligaría a comparar columnas
     * a ojo, y la mitad que se olvida siempre es la misma: el porcentaje.
     */
    queFalta(row: CofounderRow): string {
      if (!row.rankOk && !row.percentageOk) return "faltan las dos";
      if (!row.rankOk) return "falta el rango";
      return "falta el %";
    },
  },
});
